"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
/**
 * @param firestore
 * @param uid uid del usuario principal
 * @param  {boolean} justIds if set to true, getDependants only returns Id's
 */
async function getDependants(firestore, uid, justIds) {
    let dependants;
    const path = `user/${uid}/dependants`;
    try {
        const dependantRef = (0, firestore_1.collection)(firestore, path);
        dependants = await (0, firestore_1.getDocs)(dependantRef);
    }
    catch (err) {
        throw new Error(`db error ${err}`);
    }
    if (dependants.empty) {
        return [];
    }
    if (justIds === true) {
        return dependants.docs.map((document) => document.id);
    }
    return dependants.docs.map((document) => document.data());
}
exports.default = getDependants;
